import React from 'react';
import './style.css';
import { useState } from 'react';
import { db, realtimeDB } from '../../Components/Firebase/firebase';
const RegistrationForm = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [course, setCourse] = useState("");
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [gender, setGender] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name || !email || !phone || !course || !start || !end || !gender) {
            alert("Please fill in all fields");
            return;
        }
        db.collection('registration').add({
            name: name,
            email: email,
            phone: phone,
            course: course,
            start_year: start,
            end_year: end,
            gender: gender,
        })
            .then(() => {
                alert("Form Submitted");
            })
            .catch((error) => {
                alert(error.message);
            });
        const usersRef = realtimeDB.ref('users');
        usersRef.push({
            name: name,
            email: email,
            phone: phone,
            course: course,
            start_year: start,
            end_year: end,
            gender: gender,
        }, (error) => {
            if (error) {
                console.error('Error adding document to Realtime Database: ', error);
            } else {
                console.log('Document added successfully to Realtime Database!');
            }
        });

        setName('');
        setEmail('');
        setPhone('');
        setCourse('');
        setStart('');
        setEnd('');
        setGender('');

    };

    return (
        <div className="container5">
            <h1 className="form-title">Registration Form</h1>
            <form>
                <div className="main-user-info">
                    <div className="user-input-box">
                        <label for="fullName">Full Name</label>
                        <input type="text" id="fullName" name="fullName" placeholder="Enter Full Name" required value={name} onChange={(e => setName(e.target.value))} />
                    </div>

                    <div className="user-input-box">
                        <label for="email">Email</label>
                        <input type="email" id="email" name="email" placeholder="Enter Email" required value={email} onChange={(e => setEmail(e.target.value))} />
                    </div>

                    <div className="user-input-box">
                        <label for="phoneNumber">Phone Number</label>
                        <input type="text" id="phoneNumber" name="phoneNumber" placeholder="Enter Phone Number" required value={phone} onChange={(e => setPhone(e.target.value))} />
                    </div>

                    <div className="user-input-box">
                        <label for="course">Course</label>
                        <input type="text" id="course" name="course" placeholder="Enter Course" required value={course} onChange={(e => setCourse(e.target.value))} />
                    </div>

                    <div className="user-input-box">
                        <label for="start_year">Start Year</label>
                        <input type="text" id="start_year" name="start_year" placeholder="Enter Start Year" required value={start} onChange={(e => setStart(e.target.value))} />
                    </div>

                    <div className="user-input-box">
                        <label for="end_year">End Year</label>
                        <input type="text" id="end_year" name="end_year" placeholder="Enter End Year" required value={end} onChange={(e => setEnd(e.target.value))} />
                    </div>

                    <div className="gender-details-box">
                        <span className="gender-title">Gender</span>
                        <div className="gender-category">
                            <input type="radio" name="gender" id="male" value="male" checked={gender === "male"} required onChange={(e => setGender(e.target.value))} />
                            <label for="male">Male</label>

                            <input type="radio" name="gender" id="female" value="female" checked={gender === "female"} required onChange={(e => setGender(e.target.value))} />
                            <label for="female">Female</label>

                            <input type="radio" name="gender" id="other" value="other" checked={gender === "other"} required onChange={(e => setGender(e.target.value))} />
                            <label for="other">Other</label>
                        </div>
                    </div>
                </div>

                <div className="form-submit-btn" onClick={handleSubmit}>
                    <input type="submit" value="Register" />
                </div>
            </form>
        </div>
    );
};

export default RegistrationForm;
